<template>
  <v-card>
    <v-card-title class="primary white--text headline">
      <span>{{ volumeDataTitle }}</span>
      <v-spacer/>
      <BaseDialogActions hideRefresh />
    </v-card-title>
    <v-card-text>
      <FormWrapper
        :buttonText="$t('reviewed')"
        @submit="$emit('reviewed')"
      >
        <v-container fluid>
          <v-row dense>
            <v-col>
              <DataTable
                :items="propVolumeData.segmentVolumes"
                :headers="volumeColumnSet"
                :customCells="volumeCustomColumns"
                class="pt-2"
              >
                <template #filters>
                  <v-row align="center" dense v-if="propVolumeData.region > 0">
                    <v-col cols="auto">
                      <v-chip small outlined>
                        <span>
                          <Icon margin="" iconColor="secondary" :icon="iconHelpers.getIconForObjectType('region')" :tooltipText="$t('region')"></Icon>
                          {{ getScalingRegionName(propVolumeData.region) }}
                        </span>
                      </v-chip>
                    </v-col>
                  </v-row>
                </template>
                <template #attributes="{ item }">
                  <Icon
                    v-if="showButtLogIcon(item)"
                    :icon="'butt-log'"
                    :tooltipText="$t('buttLog')"
                    :small="false"
                    iconColor="grey darken-2"
                  />
                </template>
                <template #species="{ item }">
                  <span>
                    {{ findSpeciesName(item.speciesId) }}
                  </span>
                </template>
                <template #grade="{ item }">
                  <span>
                    {{ findGradeName(item.gradeId) }}
                  </span>
                </template>
              </DataTable>
            </v-col>
          </v-row>
        </v-container>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import TicketHeaders from '@/headers/Ticket'
import IconHelpers from '@/utils/IconHelpers'
import { ScalingRegion } from '@/utils/Enumerations.js'
export default {
  name: 'ReviewVolumeDataDialog',

  props: {
    propVolumeData: {
      type: Object,
      required: true
    },
    propSpecies: {
      type: Array,
      required: true
    },
    propGrades: {
      type: Array,
      required: true
    },
    propExtTicketNumber2: {
      type: Number,
      required: true
    }
  },

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue'),
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    Icon: () => import('@/components/helper/Icon.vue')
  },

  data: () => ({
    iconHelpers: IconHelpers,
    volumeColumnSet: undefined
  }),

  created () {
    this.volumeColumnSet = this.reviewScaleDataImportVolumeDialogHeaders.getColumns()
  },

  computed: {
    volumeCustomColumns () {
      return [
        {
          slotName: 'attributes',
          value: 'attributes'
        },
        {
          slotName: 'species',
          value: 'speciesId'
        },
        {
          slotName: 'grade',
          value: 'gradeId'
        }
      ]
    },
    volumeDataTitle () {
      return this.$t('scaleDataDetailsDialogTitle', { ticketNumber: this.propExtTicketNumber2 })
    },
    volumeDataChips () {
      return {
        region: this.propVolumeData.region,
        scaleRule: this.propVolumeData.scaleRule
      }
    },
    reviewScaleDataImportVolumeDialogHeaders () {
      return TicketHeaders.reviewScaleDataImportVolumeDialogHeaders()
    }
  },

  methods: {
    findSpeciesName (speciesId) {
      const species = this.propSpecies.find(s => s.speciesId === speciesId)
      return species.commonName
    },
    findGradeName (gradeId) {
      const grade = this.propGrades.find(g => g.gradeId === gradeId)
      return grade.name
    },
    showButtLogIcon (item) {
      return item.buttLog && item.segmentNumber === 2
    },
    getScalingRegionName (region) {
      return ScalingRegion.fromInt(region)
    }
  }
}
</script>
